/* eslint-disable no-unused-vars -- Imports for commented-out routes are kept on
   purpose: uncommenting an entry below should be the only edit needed to bring a
   view back. Removing them would make that a two-step change that is easy to get
   wrong. */
import React from "react";

// App Imports
import MainDashboard from "views/admin/default";
import LiveIncidentsView from "views/admin/liveIncidents";
import N550Map from "views/admin/n550Map";
import Profile from "views/admin/profile";
import DataTables from "views/admin/tables";

// Auth Imports
import ResetPassword from "views/auth/ResetPassword";

// Icon Imports
import {
  MdHome,
  MdLock,
  MdFilterTiltShift,
  MdMap,
  MdBarChart,
  MdPerson,
} from "react-icons/md";

// URLs are flat: /login, /live-incidents. `area` selects the layout and the
// guard, it is not a URL segment.
//
// To hide a view, comment out its entry. There is deliberately no per-
// environment switch: every environment runs the same route table, so what you
// see in development is what production gets.
//
// RESERVED PATHS - the API and the SPA share one origin behind the reverse
// proxy, and HAProxy sends these to the backend. A page must never use them:
//   /api/*   every backend route
//   /health  infrastructure probe (HAProxy check, deploy workflow)
//
// Other fields, all resolved in utils/routeAccess.js:
//   tenants  - tenants allowed to see it. Omitted means all.
//   roles    - roles allowed to see it. Omitted means all.
//   sidebar  - false to register the route but keep it out of the menu.
//   carousel - rendered by views/auth/AuthCarousel as a sliding panel.
//
// A commented-out or filtered-out route is never registered, so it cannot be
// reached by typing its URL either. This is navigation scoping, not a
// substitute for authorization in the API.
const routes = [
  // {
  //   name: "Main Dashboard",
  //   area: "app",
  //   path: "overview",
  //   icon: <MdHome className="h-6 w-6" />,
  //   component: <MainDashboard />,
  // },
  {
    name: "Incidents Live View",
    area: "app",
    path: "live-incidents",
    icon: <MdFilterTiltShift className="h-6 w-6" />,
    component: <LiveIncidentsView />,
    tenants: ["riga", "galicia"],
  },
  {
    name: "Planning View",
    area: "app",
    path: "planning",
    icon: <MdMap className="h-6 w-6" />,
    component: <N550Map />,
    tenants: ["galicia"],
  },
  // {
  //   name: "Data Tables",
  //   area: "app",
  //   path: "data-tables",
  //   icon: <MdBarChart className="h-6 w-6" />,
  //   component: <DataTables />,
  // },
  // {
  //   name: "Profile",
  //   area: "app",
  //   path: "profile",
  //   icon: <MdPerson className="h-6 w-6" />,
  //   component: <Profile />,
  // },

  // carousel: true means the panel is rendered by views/auth/AuthCarousel,
  // which is a layout route and stays mounted so the slide animation survives
  // navigation. Order here is the left-to-right order of the panels.
  // Each still has a real URL, so registration can be linked to from an email
  // or a partner site.
  {
    name: "Login",
    area: "auth",
    path: "login",
    icon: <MdLock className="h-6 w-6" />,
    carousel: true,
  },
  {
    name: "Create Account",
    area: "auth",
    path: "register",
    carousel: true,
    sidebar: false,
  },
  {
    name: "Forgot Password",
    area: "auth",
    path: "forgot-password",
    carousel: true,
    sidebar: false,
  },
  {
    name: "Reset Password",
    area: "auth",
    path: "reset-password",
    component: <ResetPassword />,
    sidebar: false,
  },
];
export default routes;
